// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8550 ? "ed48eaa7" : chunkId) + "." + {"960":"9b33c78553a1f0fb","2484":"f448ab2dc079148c","3139":"911098222cd1246d","3754":"884c66d9a078f4bb","4243":"cc2870763812a4c6","5552":"0c419b7a2ad0d1d3","7213":"68aecdd5a444666c","8550":"b65d335191c905b0"}[chunkId] + ".js";
};